import { Inject, Injectable } from '@angular/core';
import { FileStorageInjectionToken, FileStorageServiceInterface } from '@evorait/pace-core';
import { Mutex } from 'async-mutex';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JsonMileageHistoryModel, MileageHistoryModelFromJson, MileageModel } from '../models/mileage.model';
import { StorageMileageInterface } from './storage-mileage.interface';

const KEY_MILEAGE = 'MILEAGE';

@Injectable({
    providedIn: 'root',
})
export class StorageMileageService implements StorageMileageInterface {
    private readonly mileageHistoryMutex: Mutex;
    public constructor(@Inject(FileStorageInjectionToken) private readonly fileStorage: FileStorageServiceInterface) {
        this.mileageHistoryMutex = new Mutex();
    }

    /**
     * Add a mileage in the local storage
     *
     * @param mileageHistory the mileage history to save
     * @returns {Observable<MileageModel[]>} the observable of the save process
     */
    public saveMileages(mileageHistory: MileageModel[]): Observable<MileageModel[]> {
        return this.fileStorage.storeCompressedData(this.mileageHistoryMutex, KEY_MILEAGE, mileageHistory);
    }

    public getMileages(): Observable<MileageModel[]> {
        return this.fileStorage
            .loadCompressedData<JsonMileageHistoryModel[]>(this.mileageHistoryMutex, KEY_MILEAGE)
            .pipe(
                map((jsonMileageHistoryModels) => {
                    return jsonMileageHistoryModels.map(
                        (jsonMileageHistoryModel) => new MileageHistoryModelFromJson(jsonMileageHistoryModel),
                    );
                }),
            );
    }
}
